export class vendedor
{
    public codigo: number;
    public sucursal_codigo: number;
    public rut_empresa: number;
    public nombre: string;
    public comision: number;
    public fono1: string;
    public fono2: string;
    public estado: boolean;
    public territorio_codigo: number;
    public rut: number;
    public territorioNombre?: string;
    public listaRubro: Array<any> = [];
}